// Generated by ts-to-zod
import {z} from "zod";
import {mantineCssStyleRecordSchema} from "./primitives.zod";

export const mantineTitlePropsSchema = z.object({
	style: mantineCssStyleRecordSchema.optional(),
});
